import { http } from "../http/Http";
import { BlockUnblock, UpdateUser, User } from "../models/User";
import { ResetUserPassword } from "../models/ResetUserPassword";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";
import { ResetPasswordParameters } from "../models/ResetPasswordParameters";
import { ChangePasswordParameter } from "../models/ChangePasswordParameter";
import { ApiResponse } from "../models/ApiResponse";

export class UserService {

    //#region Queries - Commands
    getUser = async (id: number): Promise<User> => {
        const { data } = await http.get<User>(("User/GetById/" + id.toString()));
        return data;
    };

    getByExternalId = async (id: string): Promise<User> => {
        const { data } = await http.get<User>(("User/GetByExternalId/" + id));
        return data;
    };

    getUsersByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<User[]>> => {
        const { data } = await http.post<ServiceResponse<User[]>>("User/GetByFilters", apiQueryFilter);
        return data;
    };

    UpdateUser = async (updateUser: UpdateUser): Promise<ServiceResponse<User>> => {
        const { data } = await http.put<ServiceResponse<User>>("User/UpdateUser", updateUser);
        return data;
    };

    blockUnblock = async (blockUnblock: BlockUnblock): Promise<ServiceResponse<User>> => {
        const { data } = await http.put<ServiceResponse<User>>("User/BlockUnblock", blockUnblock);
        return data;
    };
    //#endregion

    //#region User Password
    CheckPassword = async (resetUserPassword: ChangePasswordParameter): Promise<boolean> => {
        const { data } = await http.post<boolean>("User/CheckPassword", resetUserPassword);
        return data;
    };

    ChangePassword = async (resetUserPassword: ChangePasswordParameter): Promise<ApiResponse> => {
        const { data } = await http.post<ApiResponse>("User/ChangePassword", resetUserPassword);
        return data;
    };

    resetUserPassword = async (resetUserPassword: ResetUserPassword): Promise<ServiceResponse<User>> => {
        const { data } = await http.post<ServiceResponse<User>>("User/ResetPassword", resetUserPassword);
        return data;
    };

    forgotPassword = async (email: string): Promise<boolean> => {
        const { data } = await http.post<boolean>("User/ForgotPassword", { Email: email});
        return data;
    };

    resetForgottenPassword = async (resetUserPassword: ResetPasswordParameters): Promise<boolean> => {
        const { data } = await http.post<boolean>("User/ResetForgottenPassword", resetUserPassword);
        return data;
    };

    FirstLoginChangePassword = async (changePasswordFormData: { Email: string, OldPassword: string, NewPassword: string }): Promise<ApiResponse> => {
        const { data } = await http.post<ApiResponse>("User/FirstLoginChangePassword", changePasswordFormData);
        return data;
    };

    FirstLoginCheckPassword = async (checkPasswordFormData: { Email: string, CurrentPassword: string }): Promise<boolean> => {
        const { data } = await http.post<boolean>("User/FirstLoginCheckPassword", checkPasswordFormData);
        return data;
    };
    //#endregion
}